//=====================================================
//　バリデーション関数
//=====================================================

import { stringToTime } from "./CommonFunc";

//空チェック
//テキスト箇所に値が入っていない場合にはエラーを返す。
export function checkEmptyTextBox(val:string, name:string):string {
    if (val.trim() === ""){
        return "入力エラー：" + name + "が入力されていません。";
    }
    return "";
}
//行の空チェック
//1行も存在しない場合、エラーメッセージを返す。引数には行の配列を渡す。
export function checkEmptyRows(rows:any[], name: string){
    if (rows.length === 0){
        return "入力エラー：" + name + "の行がありません。"
    }
    return "";
}



//-----------------------------------------------------
//文字列系
//-----------------------------------------------------

//値比較
//二つの値が一致しない場合、エラーメッセージを返す
export function checkCompare(a:string, b:string, name:string):string {
    if (a !== b){
        return "入力エラー：" + name + "が一致しません。";
    }
    return "";
}

//文字数制限
//（引数：max）文字を超える場合、エラーメッセージを返す
export function checkLengthOver(val:string, max:number, name:string):string {
    if (val.length > max){
        return "入力エラー：" + name + "は" + max + "文字以内で入力してください。";
    }
    return "";
}

//ひらがなチェック
//ひらがな以外が入力された場合、エラーメッセージを返す
export function checkHiraganaRule(val:string, name:string):string {
    if (!val.match(/^[\u3040-\u309F]+$/)){
        return "入力エラー：" + name + "はひらがなで入力してください。";
    }
    return "";
}

//半角チェック
//半角以外が入力された場合、エラーメッセージを返す
export function checkHankakuRule(val:string, name:string):string {
    if (!val.match(/^[ -~]+$/)){
        return "入力エラー：" + name + "は半角で入力してください。";
    }
    return "";
}

//半角英数字チェック
//半角英数字以外が入力された場合、エラーメッセージを返す
export function checkHankakuEisuRule(val:string, name:string):string {
    if (!val.match(/^[A-Za-z0-9]*$/)){
        return "入力エラー：" + name + "は半角英数字で入力してください。";
    }
    return "";
}


//-----------------------------------------------------
//数値系
//-----------------------------------------------------

//整数チェック
//整数でない場合、エラーメッセージを返す
export function checkPositiveInteger(val: number, name: string):string {
    if (!Number.isInteger(val)){
        return "入力エラー：" + name + "には整数を入力してください。";
    }
    return "";
}

//数値範囲チェック
//範囲外の場合、エラーメッセージを返す
export function checkRangeNumber(val: number, min: number, max: number, name: string):string {
    if (val < min || val > max){
        return "入力エラー：" + name + "は" + min + "～" + max + "の範囲で入力してください。";
    }
    return "";
}

//数値チェック（マイナス・小数点許可）
//値が数値でない場合、エラーメッセージを返す
export function checkNumber(val: string, name: string){
    if (!val.match(/^[0-9\-.]*$/)){
        return "入力エラー：" + name + "には半角数字 / -（マイナス） / .（小数点） のみを入力してください。";
    }
    if (Number(val) === NaN){
        return "入力エラー：" + name + "には数値を入力してください。";
    }
    return "";
}

//数値チェック（マイナス・禁止）
//値が数値でない場合、エラーメッセージを返す
export function checkNumberMinus(val: string, name: string){
    if (!val.match(/^[0-9\.]*$/)){
        return "入力エラー：" + name + "には正の半角数字のみを入力してください。";
    }
    if (Number(val) === NaN){
        return "入力エラー：" + name + "には数値を入力してください。";
    }
    return "";
}

//小数点以下桁数チェック
//length：許可桁数
export function checkAfterTheDecimalPoint(val: string, length:number, name: string){
    let tmpVal = val.split(".");
    if (tmpVal.length > 1){
        if (tmpVal[1].length > length){
            return "入力エラー：" + name + "の小数点以下は" + length + "桁までで入力してください。";
        }
    }
    return "";
}


//-----------------------------------------------------
//フォーマット系
//-----------------------------------------------------

//パスワードルールチェック
//パスワードルール（8文字以上の英数字）に乗っ取っていない値の場合、エラーメッセージを返す
export function checkPasswordRule(val:string, name:string):string {
    if (val.length < 8 || !val.match(/^[A-Za-z0-9]*$/)){
        return "入力エラー：" + name + "は8文字以上の英数字を入力してください。";
    }
    return "";
}

//メールアドレスルールチェック
//メールアドレス形式以外で、エラーメッセージを返す
export function checkMailRule(val:string, name:string):string {
    if (!val.match(/^[A-Za-z0-9]+[A-Za-z0-9_.+-]*@[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/)){
        return "入力エラー：入力された" + name + "は有効ではありません。";
    }
    return "";
}

//郵便番号ルールチェック
//○○○-○○○○でなく数字以外が入力された場合、エラーメッセージを返す
export function checkZipCodeRule(val:string, name:string):string {
    if (!val.match(/^[0-9]{3}-[0-9]{4}$/)){
        return "入力エラー：" + name + "は半角数字のハイフンありで入力してください。";
    }
    return "";
}

//電話番号ルールチェック
//○○○-○○○○でなく数字以外が入力された場合、エラーメッセージを返す
export function checkTelNumberRule(val:string, name:string):string {
    if (!val.match(/^[0-9]{2,4}-[0-9]{2,4}-[0-9]{4}$/)){
        return "入力エラー：" + name + "は半角数字のハイフンありで入力してください。";
    }
    return "";
}



//-----------------------------------------------------
//整合性系
//-----------------------------------------------------

//カートのオプション数量チェック
//サービスが選択されていない状態（0個）で、オプションが1以上の場合、エラーメッセージを返す
//s_counter：サービスの数、o_counter：オプションの数
export function checkCartOptionCounter(s_counter: number, o_counter: number):string {
    if (s_counter === 0 && o_counter > 0){
        return "入力エラー：オプションをご希望の場合は、対象のサービス数を1以上にしてください。";
    }
    return "";
}

//開始日終了日整合性チェック
//開始日が終了日より後の日付の場合、エラーメッセージを返す
export function checkReversalDate(sdate: Date, edate: Date, sdate_name:string, edate_name: string){
    if (sdate > edate){
        return "入力エラー：" + sdate_name + "には" + edate_name + "より過去の日付を入力してください。";
    }
    return "";
}

//開始期間終了期間整合性チェック
//開始期間が終了期間より後の期間の場合、エラーメッセージを返す
export function checkReversalTerm(startVal: number, endVal: number, startName: string, endName: string):string {
    if(startVal > endVal){
        return "入力エラー：" + endName + "が" + startName + "よりも前に設定されています。" ;
    }
    return "";
}

//行の開始日整合性チェック
//前行の開始日・終了日より過去の場合、エラーメッセージを返す
export function checkReversalDateRow(current_sdate: Date, before_edate: Date, name_current_sdate: string, name_before_edate: string){
    if (current_sdate < before_edate){
        return "入力エラー：" + name_current_sdate + "には前の行の" + name_before_edate + "よりも未来の日付を入力してください。";
    }
    return "";
}

//開始時間終了時間整合性チェック
//開始時間が終了時間より後の時間の場合、エラーメッセージを返す
export function checkReversalTime(sTime: string, eTime: string, sTimeName: string, eTimeName: string):string {
    if (stringToTime(sTime) > stringToTime(eTime)){
        return "入力エラー：" + sTimeName + "には" + eTimeName + "より過去の時間を入力してください。";
    }
    return "";
}

//行の開始時間整合性チェック
//前行の終了時間より過去の場合、エラーメッセージを返す
export function checkReversalTimeRow(current_sTime: string, before_eTime: string, name_current_sTime: string, name_before_eTime: string){
    if (before_eTime && stringToTime(current_sTime) < stringToTime(before_eTime)){
        return "入力エラー：" + name_current_sTime + "には前の行の" + name_before_eTime + "よりも未来の時間を入力してください。";
    }
    return "";
}


//-----------------------------------------------------
//画像系
//-----------------------------------------------------

//画像サイズチェック
//画像サイズがimageMaxSize(単位:MB)よりも大きい場合、エラーメッセージを返す
const imageMaxSize = 1;
export function checkImageSize(val:number):string {

    if (val > imageMaxSize* 1048576){
        return "画像が" + imageMaxSize + "MBを超えています。";
    }
    return "";
}